module.exports = {
    "register": "Register",
    "mobile": "Cellphone No",
    "or": "or",
    "registerWithEmail": "register with email",
    "password": "password",
    "invitationCode": "invitation code",
    "getMobileCode": "Get captcha",
    "mobileCode": "captcha",
    "notMobileCode": "no captcha?",
    "submit": "Submit",
    "haveAccount": "already have an account?",
    "login": "Login",
    "userExists": "Username is already taken",
    "emailInvalid": "Please input a valid email address",
    "mobileInvalid": "Please input a valid cellphone number",
    "passwordLength": "Password must contain 6 to 20 characters",
    "captchaEmpty": "Please finish the validation",
    "required": "Required",
    "mobileCodeInvalid": "Please input a valid captcha",
    "registerWithMobile": "register with cellphone",
    "email": "Email",
    "retryMobileCode": "retry",
    "mobileOrEmail": "phone/name/email",
    "forgetPassword": "Forgot password?",
    "accountInvalid": "Please input a valid cellphone number or email",
    "account": "Account",
    "username": "Username",
    "registerTime": "Register time",
    "lastLoginTime": "Last login",
    "edit": "Edit",
    "save": "Save",
    "cancel": "Cancel",
    "myproject": "My Project",
    "tutorials": "Tutorials",
    "samples": "Samples",
    "forum": "Forum",
    "resetPassword": "Reset password",
    "resetSuccess": "success",
    "captchaTipTitle": "The reason why don't you pick up a captcha may be: ",
    "captchaTip1": "be intercepted into a dustbin by security software",
    "captchaTip2": "be delayed by the network operator because there is trouble, be patient or click the button",
    "captchaTip3": "check your cellphone, may be it is down, owing tuition or full of message",
    "help": "Please join qq group: 598016249, contact the admin",
    "nicknameExists": "nickname exist",
    "nicknameLong": "The length of nickname should not be great than {{max}}",
    "nicknameShort": "The length of nickname should not be less than {{min}}",
    "point": "Points",
    "mywidgets": "My Widgets",
    "myorders": "My Orders",
    "switchLang": "中文",
    inviteCode: "Invitattion Code"
}


// WEBPACK FOOTER //
// ./src/i18n/locale.en.js